import {SelectorContainerFilterButtonClickEvent, WhitelabelEvent} from "../../../events/Events";
import {EventBus} from "../../../events/EventBus";

export class DropdownContainer {
    private button: HTMLElement
    private bodyContainer: HTMLElement
    private eventBus: EventBus
    private readonly applyButton: HTMLButtonElement | null
    private readonly clearButton: HTMLButtonElement | null
    private readonly onClearButtonClick: () => void;
    private readonly onClickButtonMustToggle: (isOpen: boolean, elementClicked: HTMLElement) => boolean;
    private readonly onClickButton: (isOpen: boolean, elementClicked: HTMLElement) => void;

    constructor(
        container: HTMLElement,
        onClearButtonClick: () => void = () => {
        },
        onClickButtonMustToggle: (isOpen: boolean, elementClicked: HTMLElement) => boolean = (): boolean => {
            return true
        },
        onClickButton: (isOpen: boolean, elementClicked: HTMLElement) => void = (): void => {
        },
    ) {
        this.onClearButtonClick = onClearButtonClick;
        this.onClickButtonMustToggle = onClickButtonMustToggle;
        this.onClickButton = onClickButton;
        this.eventBus = EventBus.getInstance()
        this.button = container.querySelector('.js-wl-selector-container__filter-button') as HTMLElement
        this.bodyContainer = container.querySelector('.js-wl-selector-container__content') as HTMLElement
        this.applyButton = container.querySelector('.js-wl-selector-container__content__apply-button') as HTMLButtonElement
        this.clearButton = container.querySelector('.js-wl-selector-container__content__clear-button') as HTMLButtonElement
        this.manageClick()
        this.manageVisibility()
        this.hideFilterOptions()
        this.manageClearButtonClick()
    }

    public updateLabel(value: string) {
        (this.button.querySelector(".label") as HTMLSpanElement)!.textContent = value
    }

    public updateToDefaultLabel() {
        const defaultElementValue = (this.button.querySelector(".label") as HTMLSpanElement)!.dataset.default
        if (defaultElementValue) {
            this.updateLabel(defaultElementValue)
        }
    }

    private manageClick() {
        this.button.addEventListener('click', (event) => {
            if (this.onClickButtonMustToggle(this.isOpen(), (event.target as HTMLElement))) {
                this.toggle();
            }
            this.onClickButton(this.isOpen(), (event.target as HTMLElement));
            this.notify();
        });
    }

    private manageVisibility() {
        this.eventBus.subscribe(SelectorContainerFilterButtonClickEvent.TYPE, (event: WhitelabelEvent) => {
            const clickEvent: SelectorContainerFilterButtonClickEvent = event as SelectorContainerFilterButtonClickEvent;
            if(this.button.dataset.name != clickEvent.payload.dataName) {
                this.close()
            }
        });
    }

    private notify() {
        this.eventBus.emit(new SelectorContainerFilterButtonClickEvent({
            dataName: this.button.dataset.name ?? ''
        }));
    }

    private toggle() {
        if (this.isOpen()) {
            this.close();
        } else {
            this.open()
        }
    }

    private isOpen() {
        return this.bodyContainer.classList.contains('displayed');
    }

    public open() {
        this.bodyContainer.classList.add('displayed');
        this.button.classList.add("opened")
    }

    public close() {
        this.bodyContainer.classList.remove('displayed');
        this.button.classList.remove("opened")
    }

    private hideFilterOptions() {
        document.addEventListener('click', this.closeAllFilters.bind(this));
    }

    private closeAllFilters(event: MouseEvent) {
        if (this.clickingOutsideMe(event)) {
            this.close();
        }
    }

    private clickingOutsideMe(event: MouseEvent) {
        let clickingInContainer = this.bodyContainer.contains(event.target as Node);
        let clickingInButton = this.button.contains(event.target as Node);
        return !clickingInContainer && !clickingInButton;
    }

    private manageClearButtonClick() {
        this.clearButton?.addEventListener('click', this.onClearButtonClick)
    }

    enableApplyButton() {
        if (this.applyButton) {
            this.applyButton.disabled = false
        }
    }

    disableApplyButton() {
        if (this.applyButton) {
            this.applyButton.disabled = true
        }
    }

    enableClearButton() {
        if (this.clearButton) {
            this.clearButton.disabled = false
        }
    }

    disableClearButton() {
        if (this.clearButton) {
            this.clearButton.disabled = true
        }
    }
}
